/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Payload for chat.ended */
export interface ChatEndedData {
  end: EndReason;
}

/** Event emitted when a chat session ends */
export interface ChatEndedEvent {
  data: ChatEndedData;
  /** @minLength 1 event_type must be at least 1 character */
  event_type: string;
  /** @minLength 1 session_id must be at least 1 character */
  session_id: string;
  /**
   * Store identifier as a zero-padded string. Numeric input is also accepted at runtime.
   * @minLength 1 store_id must be at least 1 character
   */
  store_id: string;
  /** @minLength 1 tenant must be at least 1 character */
  tenant: string;
  /** @minLength 1 time must be at least 1 character */
  time: string;
  /** @minLength 1 user_id must be at least 1 character */
  user_id: string;
  /**
   * @format int32
   * @min 1 version must be greater than or equal to 1
   */
  version: number;
}

/** Payload for chat.outcome */
export interface ChatOutcomeData {
  /** @minLength 1 data.category must be at least 1 character */
  category: string;
  channel?: OutcomeChannel | null;
  /** @minLength 1 data.pid must be at least 1 character */
  pid: string;
  ticket_id?: string | null;
  ticket_raised: boolean;
}

/** Event emitted when the chatbot session outcome is known */
export interface ChatOutcomeEvent {
  data: ChatOutcomeData;
  /** @minLength 1 event_type must be at least 1 character */
  event_type: string;
  /** @minLength 1 session_id must be at least 1 character */
  session_id: string;
  /**
   * Store identifier as a zero-padded string. Numeric input is also accepted at runtime.
   * @minLength 1 store_id must be at least 1 character
   */
  store_id: string;
  /** @minLength 1 tenant must be at least 1 character */
  tenant: string;
  /** @minLength 1 time must be at least 1 character */
  time: string;
  /** @minLength 1 user_id must be at least 1 character */
  user_id: string;
  /**
   * @format int32
   * @min 1 version must be greater than or equal to 1
   */
  version: number;
}

/** Payload for chat.reaction */
export interface ChatReactionData {
  /** @minLength 1 data.aid must be at least 1 character */
  aid: string;
  /** @minLength 1 data.category must be at least 1 character */
  category: string;
  comment?: string | null;
  /** @minLength 1 data.pid must be at least 1 character */
  pid: string;
  reaction: Reaction;
  reason?: ReactionReason | null;
}

/** Event emitted when a user reacts to an answer */
export interface ChatReactionEvent {
  data: ChatReactionData;
  /** @minLength 1 event_type must be at least 1 character */
  event_type: string;
  /** @minLength 1 session_id must be at least 1 character */
  session_id: string;
  /**
   * Store identifier as a zero-padded string. Numeric input is also accepted at runtime.
   * @minLength 1 store_id must be at least 1 character
   */
  store_id: string;
  /** @minLength 1 tenant must be at least 1 character */
  tenant: string;
  /** @minLength 1 time must be at least 1 character */
  time: string;
  /** @minLength 1 user_id must be at least 1 character */
  user_id: string;
  /**
   * @format int32
   * @min 1 version must be greater than or equal to 1
   */
  version: number;
}

/** Payload for chat.started */
export interface ChatStartedData {
  /** @minLength 1 data.category must be at least 1 character */
  category: string;
  /** @minLength 1 data.intent must be at least 1 character */
  intent: string;
}

/** Event emitted when a chat session is created */
export interface ChatStartedEvent {
  data: ChatStartedData;
  /** @minLength 1 event_type must be at least 1 character */
  event_type: string;
  /** @minLength 1 session_id must be at least 1 character */
  session_id: string;
  /**
   * Store identifier as a zero-padded string. Numeric input is also accepted at runtime.
   * @minLength 1 store_id must be at least 1 character
   */
  store_id: string;
  /** @minLength 1 tenant must be at least 1 character */
  tenant: string;
  /** @minLength 1 time must be at least 1 character */
  time: string;
  /** @minLength 1 user_id must be at least 1 character */
  user_id: string;
  /**
   * @format int32
   * @min 1 version must be greater than or equal to 1
   */
  version: number;
}

/** Payload for chat.submitted */
export interface ChatSubmittedData {
  /** @minLength 1 data.category must be at least 1 character */
  category: string;
  /** @minLength 1 data.pid must be at least 1 character */
  pid: string;
}

/** Event emitted when a user submits a prompt */
export interface ChatSubmittedEvent {
  data: ChatSubmittedData;
  /** @minLength 1 event_type must be at least 1 character */
  event_type: string;
  /** @minLength 1 session_id must be at least 1 character */
  session_id: string;
  /**
   * Store identifier as a zero-padded string. Numeric input is also accepted at runtime.
   * @minLength 1 store_id must be at least 1 character
   */
  store_id: string;
  /** @minLength 1 tenant must be at least 1 character */
  tenant: string;
  /** @minLength 1 time must be at least 1 character */
  time: string;
  /** @minLength 1 user_id must be at least 1 character */
  user_id: string;
  /**
   * @format int32
   * @min 1 version must be greater than or equal to 1
   */
  version: number;
}

/** Payload for chat.viewsource */
export interface ChatViewSourceData {
  /** @minLength 1 data.category must be at least 1 character */
  category: string;
  /** @minLength 1 data.pid must be at least 1 character */
  pid: string;
}

/** Event emitted when a user clicks View Source */
export interface ChatViewSourceEvent {
  data: ChatViewSourceData;
  /** @minLength 1 event_type must be at least 1 character */
  event_type: string;
  /** @minLength 1 session_id must be at least 1 character */
  session_id: string;
  /**
   * Store identifier as a zero-padded string. Numeric input is also accepted at runtime.
   * @minLength 1 store_id must be at least 1 character
   */
  store_id: string;
  /** @minLength 1 tenant must be at least 1 character */
  tenant: string;
  /** @minLength 1 time must be at least 1 character */
  time: string;
  /** @minLength 1 user_id must be at least 1 character */
  user_id: string;
  /**
   * @format int32
   * @min 1 version must be greater than or equal to 1
   */
  version: number;
}

export interface ChatbotErrorEmbedded {
  errors: Array<ChatbotErrorItem>;
}

export interface ChatbotErrorItem {
  _embedded: Record<string, object>;
  _links: Record<string, object>;
  logref?: string | null;
  message?: string | null;
  path?: string | null;
}

/** Micronaut error envelope returned for chatbot request errors */
export interface ChatbotErrorResponse {
  _embedded?: ChatbotErrorEmbedded | null;
  logref?: string | null;
  message?: string | null;
  path?: string | null;
}

export type ChatbotEvent = (
  | ChatStartedEvent
  | ChatSubmittedEvent
  | ChatViewSourceEvent
  | ChatReactionEvent
  | ChatOutcomeEvent
  | ChatEndedEvent
) & {
  event_type?: string;
  session_id?: string | null;
};

export interface ConsumeParams {
  from?: string | null;
  /** @default false */
  from_beginning?: boolean;
  /**
   * @format int32
   * @default 100
   */
  max_messages?: number;
  /**
   * @format int64
   * @default 2000
   */
  timeout_ms?: number;
  to?: string | null;
  topic?: string | null;
}

export interface ConsumedRecord {
  timestamp: string;
  value?: string | null;
}

/** Reason why a chat session ended */
export enum EndReason {
  UserClosed = 'user_closed',
  Timeout = 'timeout',
  Error = 'error',
  NavAway = 'nav_away',
  TicketRaised = 'ticket_raised',
}

export interface HelixPayload {
  Action?: string | null;
  entry_details: HelixPayloadEntryDetails;
  /** @minLength 1  */
  entry_event: string;
  entry_id?: string | null;
  form_name?: string | null;
  record_id?: string | null;
  webhook_id?: string | null;
}

export interface HelixPayloadEntryDetails {
  'Assigned Group'?: string | null;
  'Assignee Login ID'?: string | null;
  'Categorization Tier 1'?: string | null;
  'Categorization Tier 2'?: string | null;
  'Categorization Tier 3'?: string | null;
  'Detailed Decription'?: string | null;
  'Full Name'?: string | null;
  /** @minLength 1  */
  'Incident Number': string;
  'Internet E-mail'?: string | null;
  'Last Modified By'?: string | null;
  /** @minLength 1  */
  'Last Modified Date': string;
  /** @format int32 */
  'Mns:WorkLog Count'?: number | null;
  'Owner Group'?: string | null;
  /** @minLength 1  */
  'Store ID': string;
  /** @minLength 1  */
  'Submit Date': string;
  'Vendor Group'?: string | null;
  z1D_SLADate?: string | null;
  Description?: string | null;
  Impact?: string | null;
  /** @minLength 1  */
  InstanceId: string;
  Priority?: string | null;
  Resolution?: string | null;
  /** @minLength 1  */
  Status: string;
  Status_Reason?: string | null;
  Submitter?: string | null;
  Urgency?: string | null;
}

/** Channel where a ticket was raised */
export enum OutcomeChannel {
  Helix = 'Helix',
  City = 'City',
}

/** Reaction direction */
export enum Reaction {
  Up = 'up',
  Down = 'down',
}

/** Optional reason for a chat reaction */
export enum ReactionReason {
  Clear = 'clear',
  Helpful = 'helpful',
  Unclear = 'unclear',
  Incorrect = 'incorrect',
  Outdated = 'outdated',
  Other = 'other',
}

export type Unit = object;
